var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileDetails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 12C13.8261 12 15.0979 11.4732 16.0355 10.5355C16.9732 9.59785 17.5 8.32608 17.5 7C17.5 5.67392 16.9732 4.40215 16.0355 3.46447C15.0979 2.52678 13.8261 2 12.5 2C11.1739 2 9.90215 2.52678 8.96447 3.46447C8.02678 4.40215 7.5 5.67392 7.5 7C7.5 8.32608 8.02678 9.59785 8.96447 10.5355C9.90215 11.4732 11.1739 12 12.5 12ZM10.7148 13.875C6.86719 13.875 3.75 16.9922 3.75 20.8398C3.75 21.4805 4.26953 22 4.91016 22H20.0898C20.7305 22 21.25 21.4805 21.25 20.8398C21.25 16.9922 18.1328 13.875 14.2852 13.875H10.7148Z",
    fill: "#28519E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileDetails);
export default __webpack_public_path__ + "static/media/ProfileDetails.a33e1f0a817de8f0b2ca2ae1c10e5d69.svg";
export { ForwardRef as ReactComponent };